import { keys, reduce, isNil, isEmpty, } from 'lodash';
import { IError } from '@utils/useForm';
import { Validations, Helpers } from '@utils/helpers';
import { MyInfoForm, MyInfoAddressForm, AddMyInfoForm } from '@models/SIO/MyInfo.model';

export const validate = (values: MyInfoForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];

  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'duties':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'Please enter your exact duties' }
        } else {
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please exclude special characters other than hyphen (-) or apostrophe (')" }
          }
        }
      }
      break;
    case 'nature':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'otherBusiness':
      if (values['nature'] === '12') {
        if (isNil(value)) {
          error = { isValid: false };
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'Please specify your nature of business of employer' }
          } else {
            if (!Validations.isDutyOfOccupationValid(value)) {
              error = { isValid: false, message: "Please exclude special characters other than hyphen (-) or apostrophe (')" }
            }
          }
        }
      }
      break;
    case 'income':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "This field cannot be empty" };
        }
      }
      break;
    case 'givname':
      break;
    case 'surname':
      break;
    case 'salutation':
      if (isNil(value)) {
        error = { isValid: false }
      }
      break;
    case 'mobileNum':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidPhoneNumber(value)) {
            error = { isValid: false, message: 'Please enter a valid mobile number' };
          }
        }
      }
      break;
    case 'emailId':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidEmail(value)) {
            error = { isValid: false, message: 'Please enter a valid email address' };
          }
        }
      }
      break;
  }
  return error;
}


export const validateAddress = (values: MyInfoAddressForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateFieldAddress(values, field) };
  }, {});
  return errors;
}

export const validateFieldAddress = (values: any, name: string) => {
  const value = values[name];

  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'postcode':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidPostalCode(value)) {
            error = { isValid: false, message: "Please enter a valid postal code" };
          }
        }
      }
      break;
    case 'street':
    case 'block':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false };
        }
      }
      break;
    case 'unit':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (values['isLanded'] === true) {
          if (!isEmpty(value) && !Validations.isValidUinit(value)) {
            error = { isValid: false, message: 'Please enter a valid unit' };
          }
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: 'This field cannot be empty' };
          } else {
            if (!Validations.isValidUinit(value)) {
              error = { isValid: false, message: 'Please enter a valid unit' };
            }
          }
        }
      }
      break
    case 'building':
      break;
  }
  return error;
}

export const validateAddMyInfoForm = (values: AddMyInfoForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateFieldAddMyInfo(values, field) };
  }, {});
  return errors;
}

export const validateFieldAddMyInfo = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'givenName':
    case 'familyName':
    case 'name':
    case 'uinfin':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        }
      }
      break;


    case 'otherRace':
      if (values['race'] === 'others') {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'Please specify your race' };
        }
      }
      break;

    case 'dob':
      const minAge = 17, maxAge = 65;
      const { day, month, year } = value;
      const stringDate = `${month}/${day}/${year}`;
      if (isNil(year) && (isNil(day) || isNil(month))) {
        error = { isValid: false };
      } else {
        if (Validations.isValidDayOfBirth(stringDate) && Number(year) > 10) {
          const refDay = new Date(stringDate);
          const aged = Helpers.getAge(refDay);
          const isInRange: number = Validations.isInRange(aged, minAge, maxAge);
          if (isInRange !== 0) {
            error = {
              isValid: false,
              message: `Only applicable for ${isInRange === - 1 ? `${minAge} Age Next Birthday and above` : `below ${maxAge} Age Next Birthday`}`
            };
          }
        } else {
          error = { isValid: false, message: "Please enter a valid date" };
        }
      }
      break
    case 'mobileno':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidPhoneNumber(value)) {
            error = { isValid: false, message: 'Please enter a valid mobile number' };
          }
        }
      }
      break;
    case 'email':
      if (isNil(value)) {
        error = { isValid: false }
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidEmail(value)) {
            error = { isValid: false, message: 'Please enter a valid email' };
          }
        }
      }
      break;

    case 'postal':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidPostalCode(value)) {
            error = { isValid: false, message: "Please enter a valid postal code" };
          }
        }
      }
      break;
    case 'unit':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: 'This field cannot be empty' };
        } else {
          if (!Validations.isValidUinit(value)) {
            error = { isValid: false, message: 'Please enter a valid unit' };
          }
        }
      }
      break
    case 'block':
    case 'street':
    case 'building':
      break;
    case 'sex':
    case 'nationality':
    case 'marital':
    case 'race':
    case 'salutation':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
  }
  return error;
}
